<template>

  <div class="bodyDiv">
    <div style="margin-right: 0">
<!--      传来的参数id值是{{id}}中英文状态：{{lan=="中文"?"你好":'hello'}}-->
      <el-breadcrumb separator="/" class="breadcrumb">
        <el-breadcrumb-item :to="{ path: '/' }">{{ $t("Nav.sy") }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t("Nav.gywm") }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t("Nav.gywm_qywh") }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="contentDiv">
      <div class="leftDiv">
        <el-menu
            default-active="2"
            >
          <el-menu-item index="1">
            <span>{{ $t("Nav.gywm_qywh") }}</span>
          </el-menu-item>
          <el-menu-item index="2" >
            <span>{{ $t("Nav.gywm_qywh") }}</span>
          </el-menu-item>
          <el-menu-item index="3" >
            <span>{{ $t("Nav.gywm_qywh") }}</span>
          </el-menu-item>
          <el-menu-item index="4">
            <span>{{ $t("Nav.gywm_qywh") }}</span>
          </el-menu-item>
        </el-menu>
      </div>
      <div class="rightDiv">
        <span v-if="lan=='中文'" v-html="info">

        </span>
        <span v-else v-html="infoEN">

        </span>
      </div>
    </div>
  </div>

</template>

<script setup>
import {ref,toRef,computed ,reactive} from 'vue'
import { useI18n } from 'vue-i18n'//要在js中使用国际化

const {locale} = useI18n()
const id = ref(0)

const name2=ref("二级菜单");
const res = reactive({"total":1,"rows":[{"searchValue":null,"createBy":null,"createTime":null,"updateBy":null,"updateTime":null,"remark":null,"params":{},"articleid":"03f0efcf93684a14a3a363ca152d3698","caption":"","languageid":null,"compyid":null,"entryid":"27","createdate":"2020-10-28 10:50:51","content":"<p><img src=\"http://img.www.ejianlong.com/website/20210510/08460373652f6d.jpg\" alt=\"\" width=\"857\" height=\"953\" /></p>","workplace":null,"address":null,"postalcode":null,"tel":null,"imgurl":"","fax":null,"attr1a":"99","attr2a":"0","attr3a":null,"createtime":null,"captionEN":null,"contentEN":"<p><img src=\"http://img.www.ejianlong.com/website/assets/09232067937682.jpg\" alt=\"\" width=\"857\" height=\"953\" /></p>","addressEN":null,"postalcodeEN":null,"telEN":null,"createdateEN":"28 October 2020","isEnglish":null,"imgurlEN":null,"applyOverTime":null}],"code":"200","msg":"成功"})

const info = '<p><img src=\"http://img.www.ejianlong.com/website/20210510/08460373652f6d.jpg\" alt=\"\" width=\"857\" height=\"953\" /></p>';
const infoEN = '<p><img src=\"http://img.www.ejianlong.com/website/assets/09232067937682.jpg\" alt=\"\" width=\"857\" height=\"953\"/></p>';
let lan = computed(() => {
  if (locale.value=='zh'){
    return '中文'
  }else {
    return '英文'
  }

})

// watch(useI18n.locale, (newX) => {
//   console.log(`lan is ${newX}`)
// })


</script>

<style scoped>
el-menu-item{

  background-color: #67C23A;
}


</style>
